var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-wrapper"},_vm._l((_vm.alerts),function(alert,$index){return _c('Alert',{key:$index,attrs:{"alert-idx":$index,"alert-msg":alert.msg,"alert-class":alert.class,"dismiss-timeout":alert.timeout}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }